import { Datepicker } from 'vanillajs-datepicker';
import nl from 'vanillajs-datepicker/locales/nl';
Object.assign(Datepicker.locales, nl);
import { getKeyboardFocusableElements, scrollPageTo } from '../utils';
import scrollLock from 'scroll-lock';


export default class AgendaFilter {
    constructor(elm, menu) {
        this.elm = elm;
        this.menu = menu;

        this.breakpoint = window.matchMedia('(max-width:991px)');

        this.modals = this.elm.querySelectorAll('[data-modal-wrapper]');

        this.modalBackdrops = this.elm.querySelectorAll('[data-modal-backdrop]');
        this.modalBackdrops.forEach(button => {
            button.addEventListener('click', evt => {
                evt.preventDefault();
                this.closeModal(button.closest('[data-modal-wrapper]'));
            });
        });

        this.closeModalButtons = this.elm.querySelectorAll('[data-close-modal]');
        this.closeModalButtons.forEach(button => {
            button.addEventListener('click', evt => {
                evt.preventDefault();
                this.closeModal(button.closest('[data-modal-wrapper]'));
            });
        });
        this.modalButtons = this.elm.querySelectorAll('[data-modal-button]');
        this.modalButtons.forEach(button => {
            button.addEventListener('click', evt => {
                evt.preventDefault();

                const modal = button.closest('[data-modal-wrapper]');
                this.toggleModal(modal);
            });
        });


        const searchInput = this.elm.querySelector('[data-search-input]');
        const genreCheckboxes = this.elm.querySelectorAll('[data-genre-checkbox]');
        const typeCheckboxes = this.elm.querySelectorAll('[data-type-checkbox]');
        const presetDateRadios = this.elm.querySelectorAll('[data-preset-date-radio]');
        const datepickerRadio = this.elm.querySelector('[data-datepicker-radio]');

        this.searchButton = document.querySelector('[data-search-button]');
        this.searchButton.addEventListener('click', (e) => {
            e.preventDefault();

            scrollPageTo(this.elm.closest('header'), 1000);
            setTimeout(() => {
                searchInput.focus();

                this.menu.close();
            }, 1000);

        });

        // Focus search
        if (window.location.hash == '#focus') {
            searchInput.focus();
        }

        // Preset Radios
        presetDateRadios.forEach(radio => {
            radio.addEventListener('click', () => {
                datepickerRadio.removeAttribute('checked');
                datepicker.setDate({
                    clear: true
                });
            });
        });

        // Datepicker
        const elem = document.querySelector('[data-datepicker]');
        const datepicker = new Datepicker(elem, {
            format: 'y-m-d',
            language: 'nl',
            todayHighlight: true
        });

        const datepickerRadioVal = datepickerRadio.getAttribute('value')
        if (datepickerRadioVal) {
            datepicker.setDate(datepickerRadioVal);
        }

        elem.addEventListener('changeDate', data => {
            const formattedDate = Datepicker.formatDate(data.detail.date, 'y-m-d');
            if (formattedDate) {
                datepickerRadio.setAttribute('value', formattedDate);
                datepickerRadio.setAttribute('checked', true);

                presetDateRadios.forEach(radio => {
                    radio.removeAttribute('checked');
                });
            }
        });

        // Keyboard
        window.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                if (this.activeModal) {
                    this.closeModal(this.activeModal);
                }
            }
            if (e.key === 'Tab' || e.key === 9) {
                if (this.activeModal) {
                    if (e.shiftKey) {
						/* shift + tab */ if (document.activeElement === this.firstFocusableEl) {
                            this.lastFocusableEl.focus();
                            e.preventDefault();
                        }
                    } /* tab */ else {
                        if (document.activeElement === this.lastFocusableEl) {
                            this.firstFocusableEl.focus();
                            e.preventDefault();
                        }
                    }
                }
            }
        });

        // Reset
        const clearAllButton = this.elm.querySelector('[data-reset-form]');
        if (clearAllButton) {
            clearAllButton.addEventListener('click', evt => {
                evt.preventDefault();

                searchInput.setAttribute('value', '');

                presetDateRadios.forEach(radio => {
                    radio.removeAttribute('checked');
                });
                datepickerRadio.removeAttribute('checked');

                genreCheckboxes.forEach(checkbox => {
                    checkbox.removeAttribute('checked');
                });

                typeCheckboxes.forEach(checkbox => {
                    checkbox.removeAttribute('checked');
                });

                this.elm.submit();
            });
        }

        const resetButtons = this.elm.querySelectorAll('[data-reset-value]');
        resetButtons.forEach(resetButton => {
            resetButton.addEventListener('click', evt => {
                evt.preventDefault();

                const valueToReset = resetButton.getAttribute('data-reset-value');
                if (valueToReset) {
                    const fieldToReset = this.elm.querySelector('[value="' + String(valueToReset) + '"]');
                    if (fieldToReset) {
                        fieldToReset.setAttribute('value', '');
                        fieldToReset.removeAttribute('checked');
                    }
                }

                this.elm.submit();
            });
        });

    }

    toggleModal(elm) {
        if (elm.classList.contains('c-filter-button-wrapper--open')) {
            this.closeModal(elm);
        } else {
            this.openModal(elm);
        }
    }

    openModal(elm) {
        this.modals.forEach(modal => {
            this.closeModal(modal);
        });
        elm.classList.add('c-filter-button-wrapper--open');

        elm.querySelector('[data-modal-button]').classList.add('c-raised-button--locked');
        this.activeModal = elm;

        this.keyboardFocusableElements = getKeyboardFocusableElements(elm);
        this.firstFocusableEl = this.keyboardFocusableElements[0];
        this.lastFocusableEl = this.keyboardFocusableElements[this.keyboardFocusableElements.length - 1];
        if (this.firstFocusableEl) {
            this.firstFocusableEl.focus();
        }

        if (this.breakpoint.matches) {
            scrollLock.disablePageScroll(elm.querySelector('.c-filter-modal'));
        }
    }

    closeModal(elm) {
        elm.classList.remove('c-filter-button-wrapper--open');
        elm.querySelector('[data-modal-button]').classList.remove('c-raised-button--locked');
        this.activeModal = null;

        this.keyboardFocusableElements = null;
        this.firstFocusableEl = null;
        this.lastFocusableEl = null;

        elm.querySelector('[data-modal-button]').focus();

        if (this.breakpoint.matches) {
            scrollLock.enablePageScroll(elm.querySelector('.c-filter-modal'));
        }

    }
}
